<div class="container" [@inOutAnimation]="this.isComputing ? 'in' : 'out'">
  <mat-spinner class="spinner"></mat-spinner>
</div>
